export default class JoinUsFormUpload {

    constructor() {
        this.settings = {
            form: document.querySelector('.join-us')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.form != null) {
            const fileInputContainers = document.querySelectorAll('.cv-upload .ginput_container.ginput_container_fileupload');

            fileInputContainers.forEach(container => {
                const fileInput = container.querySelector('input[type="file"]');
                const validationMessage = container.querySelector('.validation_message--hidden-on-empty');

                if (fileInput) {
                    fileInput.addEventListener('change', function () {
                        if (fileInput.files.length > 0) {
                            if (validationMessage) {
                                validationMessage.remove();
                            }

                            let successMessage = container.querySelector('.file-upload-successful');

                            if (!successMessage) {
                                successMessage = document.createElement('div');
                                successMessage.className = 'file-upload-successful';
                                container.appendChild(successMessage);
                            }

                            successMessage.textContent = 'File uploaded successfully';
                        } else {
                            const existingSuccessMessage = container.querySelector('.file-upload-successful');
                            
                            if (existingSuccessMessage) {
                                existingSuccessMessage.remove();
                            }

                            if (!container.querySelector('.validation_message--hidden-on-empty')) {
                                const newValidationMessage = document.createElement('div');
                                newValidationMessage.className = 'gfield_description validation_message gfield_validation_message validation_message--hidden-on-empty';
                                newValidationMessage.textContent = 'Please upload a valid file.';
                                container.appendChild(newValidationMessage);
                            }
                        }
                    });
                }
            });
        };

    }

}

new JoinUsFormUpload();
